import { flashbags } from '@organisms/flashbags';

export const initHeader = () => {
  if (document.querySelector('#flashbags')) {
    flashbags();
  }
};
